import React, {useContext, useEffect} from "react";
import {VideoContext} from "../../../context/videoContext";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingContent from "../../common/LoadingContent";
import LoadingNoMoreContent from "../../common/LoadingNoMoreContent";
import VideoItem from "../section/VideoItem";

const Friends = () => {
	const {
		friends, loadMoreVideos, fetchVideos
	} = useContext(VideoContext);

	useEffect(() => {
		fetchVideos('friends', true);
	}, [fetchVideos]);

	return (
		<div>
			{friends.videos.length > 0 ? (
				<InfiniteScroll
					dataLength={friends.videos.length}
					next={() => loadMoreVideos('friends')}
					hasMore={friends.hasMore}
					loader={<LoadingContent/>}
					endMessage={<LoadingNoMoreContent/>}
				>
					{friends.videos.map((video, index) => (
						<div className="mb-4" key={video.video_id}>
							<VideoItem video={video}/>
						</div>
					))}
				</InfiniteScroll>
			) : (
				<div>
					{friends.videos.loading ? (
						<LoadingContent/>
					) : (
						<LoadingNoMoreContent/>
					)}
				</div>
			)}
		</div>
	);
}

export default Friends;